/**
 * Produce the enroll dialogs and process enrollments.
 */
var Enroll = {
	initialize: function () {
		$(document).on("click", "[data-enroll-class]", function () {
			Enroll.dialog($(this).data("enroll-class"));
		});
	},

	dialog: function (class_id) {
		$.post(
			"/m/school/ajax.php",
			{
				action: "get-enroll-info",
				class_id: class_id,
				code: AoPS.bd.hasOwnProperty("hash") ? AoPS.bd.hash : 0,
			},
			function (data) {
				var response = data.response;
				if (data.error_msg) {
					AoPS.Ui.Modal.showAlertQuick(
						'<span data-hj-suppress="" data-hj-masked="">' +
							data.error_msg +
							"</span>"
					);
				} else if (response.enroll_status === "full") {
					AoPS.Ui.Modal.showAlertQuick("Sorry, the class is full");
				} else if (response.enroll_status === "waitlist") {
					AoPS.Ui.Modal.showAlertQuick(
						"This class currenlty has a waitlist.<br><br><a href=''>Click here to join the waitlist.</a>"
					);
				} else if (response.enroll_status === "closed") {
					AoPS.Ui.Modal.showAlertQuick(
						"Sorry, this class is closed to new enrollments."
					);
				} else {
					var enrollModel = new AoPS.Enroll.Models.Enroll({
						...response,
					});
					AoPS.EnrollUtils.displayEnroll({
						title:
							"Enroll in " + response.name + " (" + response.class_id + ")",
						productName: response.name,
						enrollModel,
					});
				}
			}
		);
	},
};

$(function () {
	Enroll.initialize();

	// Check if coming from registration page
	if (AoPS.bd.hasOwnProperty("enrolling")) {
		if (AoPS.bd.enrolling.hasOwnProperty("class_id")) {
			Enroll.dialog(AoPS.bd.enrolling.class_id);
		}
	}
});
